export default {"src":"/_next/static/media/google-star-empty.0c45585e.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};